$ = require('jquery')

module.exports =
	init: (payload) ->
		{$target} = payload

		$(document)
			# link slide
			.on('click', '.link-slide', (e) ->
				e.preventDefault()

				$this = $(@)
				id = $this.attr('href')
				$element = $(id)

				if $element.hasClass('box-accordion__box')
					if !$element.closest('.box-accordion__item').hasClass('is-open')
						$('.box-accordion__title__link[href=' + id + ']').trigger('click')

				else if $element.hasClass('box-tabs__fragment')
					if !$element.hasClass('is-active')
						$('.box-tabs .js-tab-links[href=' + id + ']').trigger('click')

				$('body, html').animate(
					scrollTop: $element.offset().top
				500)


			)



// WEBPACK FOOTER //
// ./src/js/components/links.coffee